import { SelectOption } from "common/components/Select";
import { ContentStatusFilterValue } from "domain/constants";
import {
  ContentFragment,
  ContentListFragment,
  ContentStatus,
  SimulationCaseListFragment_simulationCaseList,
} from "__generated__/types";

export function listFilter(
  data: ContentListFragment,
  statusFilterValue: ContentStatusFilterValue,
): boolean {
  switch (statusFilterValue) {
    case ContentStatusFilterValue.ARCHIVED:
      return data.status == ContentStatus.ARCHIVED;
    case ContentStatusFilterValue.DRAFT:
      return data.status == ContentStatus.DRAFT;
    case ContentStatusFilterValue.PUBLISHED:
      return data.status == ContentStatus.PUBLISHED;
    case ContentStatusFilterValue.ALL:
      return true;
  }
}

export function simulationListFilter(
  data: SimulationCaseListFragment_simulationCaseList,
  statusFilterValue: ContentStatusFilterValue,
): boolean {
  switch (statusFilterValue) {
    case ContentStatusFilterValue.ARCHIVED:
      return data.status == ContentStatus.ARCHIVED;
    case ContentStatusFilterValue.DRAFT:
      return data.status == ContentStatus.DRAFT;
    case ContentStatusFilterValue.PUBLISHED:
      return data.status == ContentStatus.PUBLISHED;
    case ContentStatusFilterValue.ALL:
      return true;
  }
}

export const removeTypename = <T>(obj: T): T => {
  if (Array.isArray(obj)) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return obj.map((item) => removeTypename(item)) as T;
  } else if (obj && typeof obj === "object") {
    const newObj: any = {};
    for (const key in obj) {
      if (key !== "__typename") {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        newObj[key] = removeTypename((obj as Record<string, unknown>)[key]);
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return newObj;
  }
  return obj;
};

interface EntityWithContent {
  content: {
    status: ContentStatus;
    __typename: string;
  };
}

export function chainFilters<T>(...filters: Array<(el: T) => boolean>) {
  return (el: T): boolean => filters.every((filter) => filter(el));
}

export function noDeletedStatusFilter(status: ContentStatus): boolean {
  return status !== ContentStatus.DELETED;
}

export const statusFilter =
  <T extends EntityWithContent>(status: ContentStatusFilterValue) =>
  (element: T): boolean =>
    status === ContentStatusFilterValue.ALL ||
    element.content.status.toString() === status.toString();

export const typeFilter =
  <T extends EntityWithContent>(typename?: string) =>
  (element: T) =>
    typename === element.content.__typename;

export const contentToSelectOption = (
  content: ContentFragment,
): SelectOption => {
  return {
    key: content.id,
    value: content.id,
    label: content.title,
  };
};
